var slideWrapper = $(".home_slider"),
  lazyCounter = 0;

// POST commands to YouTube or Vimeo API
function postMessageToPlayer(player, command) {
  if (player == null || command == null) return;
  player.contentWindow.postMessage(JSON.stringify(command), "*");
}

// When the slide is changing
function playPauseVideo(slick, control) {
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[1];
  player = currentSlide.find("iframe").get(0);
  startTime = currentSlide.data("video-start");

  if (slideType === "vimeo") {
    switch (control) {
      case "play":
        if (
          startTime != null &&
          startTime > 0 &&
          !currentSlide.hasClass("started")
        ) {
          currentSlide.addClass("started");
          postMessageToPlayer(player, {
            method: "setCurrentTime",
            value: startTime,
          });
        }
        postMessageToPlayer(player, {
          method: "play",
          value: 1,
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          method: "pause",
          value: 1,
        });
        break;
    }
  } else if (slideType === "youtube") {
    switch (control) {
      case "play":
        postMessageToPlayer(player, {
          event: "command",
          func: "mute",
        });
        postMessageToPlayer(player, {
          event: "command",
          func: "playVideo",
        });
        break;
      case "pause":
        postMessageToPlayer(player, {
          event: "command",
          func: "pauseVideo",
        });
        break;
    }
  } else if (slideType === "video") {
    video = currentSlide.children("video").get(0);
    if (video != null) {
      if (control === "play") {
        video.play();
      } else {
        video.pause();
      }
    }
  }
}

// DOM Ready
$(function () {
  // Initialize
  slideWrapper.on("init", function (event, slick, currentSlide) {
    console.log(slick);
    var cur = $(slick.$slides[slick.currentSlide]),
      next = cur.next(),
      prev = cur.prev();
    prev.addClass("slick-sprev");
    next.addClass("slick-snext");
    cur.removeClass("slick-snext").removeClass("slick-sprev");
    slick.$prev = prev;
    slick.$next = next;
    slick = $(slick.$slider);
    setTimeout(function () {
      playPauseVideo(slick, "play");
    }, 1000);
    //resizePlayer(iframes, 16/9);
  });
  slideWrapper.on(
    "beforeChange",
    function (event, slick, currentSlide, nextSlide) {
      var cur = $(slick.$slides[nextSlide]);
      console.log(slick.$prev, slick.$next);
      slick.$prev.removeClass("slick-sprev");
      slick.$next.removeClass("slick-snext");
      (next = cur.next()), (prev = cur.prev());
      prev.prev();
      prev.next();
      prev.addClass("slick-sprev");
      next.addClass("slick-snext");
      slick.$prev = prev;
      slick.$next = next;
      cur.removeClass("slick-next").removeClass("slick-sprev");
      slick = $(slick.$slider);
      playPauseVideo(slick, "pause");
    }
  );
  slideWrapper.on("afterChange", function (event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick, "play");
  });

  //start the slider
  slideWrapper.slick({
    slidesToShow: 3,
    infinite: true,
    autoplay: false,
    centerMode: true,
    variableWidth: false,
    centerPadding: "260px",
    speed: 400,
    arrows: true,
    focusOnSelect: true,
    dots: false,
    prevArrow:
      '<button class="custom-prev"><svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2L2 11L11 20" stroke="white" stroke-width="3" stroke-linejoin="round"/></svg></button>',
    nextArrow:
      '<button class="custom-next"><svg width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L11 11L2 20" stroke="white" stroke-width="3" stroke-linejoin="round"/></svg></button>',
    
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: false,
        centerPadding: '0',
        slidesToShow: 1
      }
    }
  ]
  });
});

// Resize event
/* $(window).on("resize.slickVideoPlayer", function(){  
  resizePlayer(iframes, 16/9);
});
*/
